import React, { useState } from "react";
import DOMPurify from "dompurify";
import background from "./../img/backgroundHome.png";
import logo from "./../img/logore.png";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../reducers/users/userSlices";
import { BaseUrlServ } from "../services/axios/AxiosEndpoints";
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Box,
  Link,
} from "@mui/material";
//import CleanCacheLoadApp from "../utils/CleanCacheLoadApp";

import bcrypt from "bcryptjs";
import { setUserSession } from "../reducers/sessions/sessionauthcodeSlices";

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userData, setUserData] = useState();
  const [claveData, setClaveData] = useState();
  const [codPSSData, setCodPSSData] = useState();
  const [descriptionData, setDescriptionData] = useState();

  //const { usuario, clave, codPss, descripcion, token } = useSelector((state) => state.user);
  const { usersession } = useSelector((state) => state.sessionuser);
  //const { plastico, mensage } = useSelector((state) => state.authcode);

  const validate = () => {
    const errors = {};

    if (!userData) {
      errors.userData = "Este campo no puede estar vacio";
    } else if (userData.userData.length > 15) {
      errors.userData = "El caampo no debe estar vacio";
    }

    if (!claveData) {
      errors.claveData = "Este campo no puede estar vacio";
    } else if (claveData < 8) {
      errors.claveData = "El campo debe tener de 8 a 15 caracteres.";
    }

    if (!codPSSData) {
      errors.codPSSData = "Este campo no puede estar vacio";
    }

    return errors;
  };

  const HandleChangeUser = (e) => {
    setUserData(e.target.value.toUpperCase());
  };

  const HandleChangeClave = (e) => {
    setClaveData(e.target.value);
  };

  const HandleChangeCodPSS = (e) => {
    setCodPSSData(e.target.value);
  };

  // Función para generar un token de sesión utilizando bcrypt
  const generateSessionToken = (userData, claveData, codPSSData) => {
    const secret = `${userData}:${claveData}`; // Clave secreta para generar el token
    const tokenString = `${userData}:${claveData}:${codPSSData}:${secret}`;
    const saltRounds = 1; // Número de rondas de hashing
    const hash = bcrypt.hashSync(tokenString, saltRounds);
    return hash;
  };

  /*
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "sessionActive" && event.newValue !== token) {
        // Si el identificador de sesión cambia en otra pestaña, significa que otro usuario ha iniciado sesión
        // Podemos realizar acciones como mostrar un mensaje de error o redirigir a la página de inicio de sesión
        // alert("Otro usuario ha iniciado sesión en otra pestaña. Se cerrará esta sesión.");
        // Aquí podrías ejecutar la lógica para cerrar la sesión o redirigir al usuario

        // Read more about isConfirmed, isDenied below
        Swal.fire({
          title: "Ya tienes una sesión activa en otra pestaña.",
          icon: "success",
          text: "Cerrando esta sesión.",
        });

        dispatch(
          setLogoutUser({
            usuario: usuario,
            clave: clave,
            codPss: codPss,
            descripcion: descripcion,
            token: token,
          })
        );

        // Cerrar sesión, eliminar el token de sesión
        localStorage.removeItem("sessionToken");
        localStorage.setItem("sessionActive", "false");

        navigate("/");
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [clave, codPss, descripcion, dispatch, navigate, token, usuario]);
  */

  const HandleSubmit = (e) => {
    e.preventDefault();

    const sanitizedUsuario = DOMPurify.sanitize(userData);
    const sanitizedClave = DOMPurify.sanitize(claveData);
    const sanitizedcodPss = DOMPurify.sanitize(codPSSData);
    const sanitizedDescripcion = DOMPurify.sanitize(descriptionData);

    if (sanitizedUsuario === "") {
      Swal.fire({
        title: "",
        text: "Los demas campos no pueden estar vacios.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else if (sanitizedClave === "") {
      Swal.fire({
        title: "",
        text: "Los demas campos no pueden estar vacios.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else if (sanitizedcodPss === "") {
      Swal.fire({
        title: "",
        text: "Los demas campos no pueden estar vacios.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else {
      axios({
        url: `${BaseUrlServ}/IniciarSesion`,
        method: "POST",
        data: JSON.stringify({
          usuario: sanitizedUsuario,
          clave: sanitizedClave,
          codPss: sanitizedcodPss,
          descripcion: sanitizedDescripcion,
          encuestar: "",
        }),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            // Genera un token único utilizando bcrypt
            const sessionToken = generateSessionToken(
              userData,
              claveData,
              codPSSData
            );

            dispatch(
              setUserSession({
                usersession: usersession,
              })
            );

            dispatch(
              setUser({
                usuario: userData,
                clave: claveData,
                codPss: codPSSData,
                descripcion: response.data.response[0].descripcion,
                encuestar: response.data.response[0].encuestar,
              })
            );

            setDescriptionData(response.data.response[0].descripcion);

            localStorage.setItem("sessionToken", sessionToken);
            localStorage.setItem("sessionActive", "true");
            
            navigate("/dashboard");
          } else {
            navigate("/");
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              Swal.fire({
                title: "",
                text: "El recurso no fue encontrado.",
                icon: "warning",
                confirmButtonText: "Ok",
              });
            } else if (error.response.status === 500) {
              Swal.fire({
                title: "",
                text: "Ha ocurrido un error en el servidor",
                icon: "warning",
                confirmButtonText: "Ok",
              });
            }

            Swal.fire({
              title: "",
              text: error.response.data,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    }
  };

  return (
    <Container
      component="main"
      maxWidth="lx"
      sx={{
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${background})`, // Reemplaza con la URL de tu imagen de fondo
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 5,
      }}
    >
      <Paper
        sx={{
          width: { xs: "100%", sm: "70%", md: "50%", lg: "30%" },
          marginTop: "70px",
          padding: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: 2,
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            marginTop: "40px",
            width: "40%",
            height: "10%", // Reemplaza con la URL de tu imagen de fondo
            backgroundSize: "cover",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        />

        <Typography
          component="h1"
          variant="h5"
          sx={{
            fontSize: { xs: "16px", sm: "16px", md: "22px", lg: "22px" },
            fontWeight: "bold",
            marginTop: "20px",
          }}
        >
          INICIAR SESIÓN
        </Typography>

        <Box
          sx={{
            width: { xs: "90%", sm: "80%", md: "80%", lg: "80%" },
            height: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "0px",
            padding: "5px",
          }}
          onSubmit={HandleSubmit}
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="usuario"
            label="Usuario"
            name="usuario"
            autoComplete="usuario"
            autoFocus
            value={userData}
            onChange={HandleChangeUser}
          />
          {validate.userData && validate.userData ? (
            <div className="errorlabel">{validate.userData}</div>
          ) : null}
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="clave"
            label="Contraseña"
            type="password"
            id="clave"
            autoComplete="clave"
            value={claveData}
            onChange={HandleChangeClave}
          />
          {validate.claveData && validate.claveData ? (
            <div className="errorlabel">{validate.claveData}</div>
          ) : null}

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="codPss"
            label="Código PSS"
            type="number"
            id="codPss"
            value={codPSSData}
            onChange={HandleChangeCodPSS}
          />
          {validate.codPSSData && validate.codPSSData ? (
            <div className="errorlabel">{validate.codPSSData}</div>
          ) : null}
          <Button
            sx={{
              width: "auto",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={HandleSubmit}
          >
            Iniciar sesión
          </Button>

          <Typography mt={2} mb={2}>
            ¿Necesitas ayuda?
            <Link
              href="https://arsrenacer.com/contactos/"
              alt="Nesecitas ayuda"
              style={{ textDecoration: "none", marginLeft: "15px" }}
            >
              Contáctanos
            </Link>
          </Typography>
        </Box>
      </Paper>
      <Box mt={8}>
        {/* Otro contenido que puedas agregar después del formulario */}
        {/* <CleanCacheLoadApp /> */}
      </Box>
    </Container>
  );
};

export default LoginForm;

/*
if (token === "" && token !== null) {
      
    } else {
      Swal.fire({
        title: "",
        text: "Ya existe una sesión abierta. Por favor, cierre esa sesión antes de continuar. Refresque esta página después de cerrar la sesión para continuar.",
        icon: "warning",
        confirmButtonText: "ACEPTAR",
      }).then((result) => {
        // Read more about isConfirmed, isDenied below
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/");
            window.location.reload();
          }, 500);
        }
      });
    }

*/
